@if (isWood) {
  <icc-select-box
    [title]="'WINDOW|Rodzaj drewna' | translate"
    [description]="(woodType$ | async).name"
    [imageUrl]="'/files/woodtype/' + (woodType$ | async).img"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isWoodSelectionDisabled()"
    (select)="openModalWood()"
  ></icc-select-box>
}

@if (showOptions) {
  <section class="optionsContainer mat-elevation-z3">
    <label class="options-title">{{ 'WINDOW|Zgrzew' | translate }}:</label>
    <mat-radio-group
      class="optionsGroup"
      [ngModel]="weldFinishType$ | async"
      (ngModelChange)="setWeldFinishType($event)"
      >
      <mat-radio-button value="V">
        {{ 'WINDOW|Zgrzew typu "V"' | translate }}
      </mat-radio-button>
      <mat-radio-button value="thin">
        {{ 'WINDOW|Zgrzew nitkowy' | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </section>
}
@if (showOptions) {
  <section class="optionsContainer mat-elevation-z3">
    <label class="options-title">{{ 'WINDOW|Odwodnienie' | translate }}:</label>
    <mat-radio-group
      class="optionsGroup"
      [ngModel]="drainagePosition$ | async"
      (ngModelChange)="setDrainage($event)"
      >
      <mat-radio-button value="front">
        {{ 'WINDOW|Od czoła' | translate }}
      </mat-radio-button>
      <mat-radio-button value="bottom">
        {{ 'WINDOW|Od dołu' | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </section>
}

@if (withAlushell && !alushellActive) {
  <section class="alushellToggle mat-elevation-z3">
    <mat-slide-toggle
      (ngModelChange)="changeAlushell($event)"
      [ngModel]="aluShell$ | async"
      >{{ 'WINDOW|Nakładka aluminiowa' | translate }}
    </mat-slide-toggle>
  </section>
}

@if ((aluShell$ | async) && extendedAlushell) {
  <section class="optionsContainer mat-elevation-z3">
    <label class="options-title">{{ 'WINDOW|Rodzaj nakładki' | translate }}:</label>
    <mat-radio-group
      class="optionsGroup"
      [ngModel]="alushellType$ | async"
      (ngModelChange)="alushellType($event)"
      >
      <mat-radio-button value="brushed">
        {{ 'WINDOW|Aluminium szczotkowane' | translate }}
      </mat-radio-button>
      <mat-radio-button value="painted">
        {{ 'WINDOW|Aluminium lakierowane' | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </section>
}
